var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hb-btn',_vm._b({on:{"click":_vm.triggerEvent}},'hb-btn',_vm.buttonProps,false),[_vm._v(" "+_vm._s(_vm.buttonProps.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }